import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button, Link } from '@material-ui/core';
import moment from 'moment';
import { Edit as EditIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  container: {
    borderBottom: `1px solid ${theme.palette.lightGrey.default}`,
    padding: '10px 16px 10px 0',
    display: 'flex',
    justifyContent: 'space-between'
  },
  danger: {
    color: 'red'
  },
  collapsed: {
    display: 'none'
  },
  warning: {
    color: 'orange'
  },
  heading: {
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginBottom: 3
  },
  subHeading: {
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginBottom: 3
  },
  textContent: {},
  buttonContent: {}
}));

const calculateExpiryPrefiex = (source, isExpired) => {
  if (source === 'training') {
    if (isExpired) {
      return 'd';
    } else {
      return 's';
    }
  } else {
    return '';
  }
};

const RecordsListInCompanyBlade = (props) => {
  const classes = useStyles();
  const {
    allCourses,
    items,
    handleAddEditClick,
    dateLabel,
    titleField,
    subTitleField,
    dateField,
    courseId,
    branchIdField,
    branchNameField,
    source
  } = props;

  return (
    <React.Fragment>
      {items &&
        items.map((item, index) => {
          return (
            <div className={classes.container} key={index}>
              <div className={classes.textContent}>
                <Typography variant="h6" className={classes.heading}>
                  {item.branchName}
                </Typography>
                <Typography variant="subtitle1" className={classes.subHeading}>
                  {item.upcomingCount > 0 || item.overdueCount > 0 ? (
                    <div>
                      <span
                        className={`${
                          item.upcomingCount === 0 ? classes.collapsed : ''
                        }`}
                      >
                        {item.upcomingCount} upcoming,{' '}
                      </span>
                      <span
                        className={`${
                          item.overdueCount > 0 ? classes.danger : ''
                        }`}
                      >
                        {item.overdueCount} overdue
                      </span>
                    </div>
                  ) : (
                    'no alerts'
                  )}
                </Typography>
              </div>
              <div className={classes.buttonContent}>
                <Link
                  href={`/admin-view/branch/${item[branchIdField]}`}
                  target="_blank"
                  className={classes.viewAsAdminButton}
                >
                  go to branch
                </Link>
              </div>
            </div>
          );
        })}
    </React.Fragment>
  );
};

export default RecordsListInCompanyBlade;
